<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
  <h5>Signin with Google to access the Firebase database</h5>
  <br>
  <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
</div>

<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
  <h1>Modifier Matrix</h1>
  <div class="matrix-container">
    <table class="table table-bordered table-sm matrix-table">
      <thead>
        <tr class="scenario-title-row">
          <th scope="col">Modifier</th>
          <th scope="col" class="scenario-header" *ngFor="let scenario of scenarios"
              [class.scenario-header-high-seq]="scenario.seqNo > 1000"
              [attr.aria-label]="scenario.displayName || scenario.id">
            <div class="scenario-header-content">
              <span>{{ scenario.displayName || scenario.id }}</span>
            </div>
          </th>
        </tr>
        <tr class="scenario-filter-row">
          <th scope="col"></th>
          <th scope="col" *ngFor="let scenario of scenarios"
              [class.scenario-header-high-seq]="scenario.seqNo > 1000">
            <button type="button" class="matrix-filter-button"
                    title="Filter by this scenario" aria-label="Filter by this scenario"
                    (click)="toggleScenarioFilter(scenarios.indexOf(scenario))">
              <i class="bi bi-funnel-fill"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of matrixRows" [hidden]="!isRowVisible(row)">
          <th scope="row">{{ row.className }}</th>
          <td *ngFor="let count of row.counts"
              [ngClass]="{ 'count-one': count === 1, 'count-many': count > 1 }">
            {{ count }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
